import React, { useState } from 'react'
import { makeStyles, Grid, Paper, Grow, Box, Button, Input, Typography } from '@material-ui/core';
import { useParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, CircleMarker, } from 'react-leaflet'
import Data from "../../data/data"
import history from '../../history/history'
import Weather from './wather/Wather'
import { GetCitiesOfState } from '../../data/utils/index'
import { BuyCity } from '../../redux/action/action';
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../utils';
// loinAddress
import Web3 from 'web3';
const useStyles = makeStyles((theme) => ({

  box1: {
    paddingTop: "120px",
    width: "100%"
  },
  courseInfo: {
    padding: "10px",
    textAlign: "center",
  },
  btn: {
    backgroundColor: "#2A265F",
    border: 0,
    borderRadius: "3px",
    boxShadow: "0 10px 10px rgba(0, 0, 0, 0.2)",
    color: "#FF5805",
    fontWeight: "bolder",
    fontSize: "16px",
    padding: '13px 15px',
    marginTop: "2rem",
    letterSpacing: "1px",
    "&:hover": {
      backgroundColor: "#2A265F",
    }

  },
  basicSlide: {
    boxShadow: "0 5px 5px rgba(0, 0, 0, 0.2),0px -5px 5px rgba(0, 0, 0, 0.2),-5px 0px 5px rgba(0, 0, 0, 0.2)",
    position: "relative",
    width: '100%',
    padding: "10px 0 10px 15px",
    fontWeight: 400,
    color: '#377D6A',
    background: '#efefef',
    border: 0,
    borderRadius: '3px',
    padding: '10px 15px',
    outline: 0,
    textIndent: 90, // Arbitrary.
    fontSize: "20px",
    transition: 'all .3s ease-in-out',


    '&::-webkit-input-placeholder': {
      color: '#efefef',
      textIndent: 90,
      fontWeight: 300,
      fontSize: "20px",
    },
  },
  buyContainer: {
    marginTop: "3rem",
    [theme.breakpoints.down("md")]: {
      marginTop: 0
    }

  }

}));
export default function Cites({ useraccount, contract }) {


  const classes = useStyles();
  const [value, setValues] = useState(0)
  let params = useParams()
  const dispatch = useDispatch()
  const Aut = useSelector(state => state.AutReducer)
  const { country, st, stateIndex, cityName, zip } = params;

  const cities = GetCitiesOfState(country, st)
  if (cities.length !== 0) {
    var citesStatsData = cities.find((item) => item.name == cityName);
  }

  var position = [citesStatsData.latitude, citesStatsData.longitude]

  const BuyHandler = (zip) => {
    if (Aut.loinAddress.find == true) {

      if (+value != 0) {

        dispatch(BuyCity(value, zip, citesStatsData, Aut.loinAddress))

      } else {
        showAlert("", 'error')
      }

    } else {

      history.push('/login')

    }

  }


  React.useEffect(() => {
    if (contract !== undefined) {
      contract.methods.cities(zip).call().then((val) => {
        setValues(val[2])
      })
    }
  }, [contract, zip])


  return (
    <Box style={{ backgroundColor: "#15244D" }} className={classes.box1} width={1}>
      <Box maxWidth="1248px" mx="auto" style={{ backgroundColor: "#fff", borderRadius: "10px" }} p="10px">
        <Grid container justify="center" direction="row-reverse" spacing={2}>
          <Grid item xs={12} sm={12} md={12} >
            <Weather Cityname={citesStatsData.name} CountryName="us" />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box>
              <MapContainer style={{ zIndex: 0 }} center={position} zoom={13} scrollWheelZoom={false}>
                <TileLayer
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <CircleMarker
                  center={position}
                  pathOptions={{ color: 'red' }}
                  radius={40}>
                </CircleMarker>
                <Marker position={position}>
                  <Popup>
                    City : {citesStatsData.name} <br />
                   State : {Data[stateIndex].name} <br />
                   latitude : {citesStatsData.latitude} <br />
                   longitude : {citesStatsData.longitude} <br />
                  </Popup>
                </Marker>
              </MapContainer>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} className={classes.buyContainer}>
            <Box className={classes.courseInfo}>
              <Typography style={{ fontFamily: "Zen Dots,cursive", fontSize: "1.5rem", color: "#001F61" }}>BUY UNITED STATES AND CITY</Typography>
              <Typography>state:{Data[stateIndex].name}/city:{citesStatsData.name}  </Typography>
              <br />
            </Box>
            <Input className={classes.basicSlide} value={useraccount ? value ? +value == 0 ? 'this city is not open for buy' : Web3.utils.fromWei(value) : "Loading..." : " Connect to Wallet and Register..........."} onChange={(e) => setValues(e.target.value)} id="education" type="text" placeholder="Min 2.5 BTC" />
            <Box style={{ width: "100%", }}>
              <Button className={classes.btn} fullWidth disabled={useraccount ? +value == 0 ? "Loading....." : false : true} onClick={() => BuyHandler(citesStatsData.zip)} color="primary" >Buy</Button>
            </Box>


          </Grid>
        </Grid>

      </Box>
    </Box>
  )
}
